/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import { combineReducers } from "redux";
import aplicationDetailsReducer from "./Application-details/ApplicationDetailsReducer";
import applicationidDetailsReducer from "./appId-details/AppIdDetailsReducer";
import categoryDetailsReducer from "./Category/CategoryReducer";
import teamDetailsReducer from "./team-details/TeamDetailsReducer";
import languageDetailsReducer from "./languages-details/LanguageDetailsReducer";
import countryDetailsReducer from "./Country-details/CountryDetailsReducer";
import vehiclesDetailsReducer from "./Vehicles-details/VehiclesDetailsReducer";
import cpuDetailsReducer from "./CPU-details/CpuDetailsReducer";
import screenshotDetailsReducer from "./Screenshots-upload/ScreenshotsUploadReducer";
import bannerDetailsReducer from "./banner-upload/bannerUploadReducer";
import applicationAdditonalDocumentReducer from "./AdditionalDocument/AdditionalDocumentReducer";
import applicationBinaryDetailsReducer from "./AddNewApkFIleCreateRelease/AddNewApkFileCreateReleaseReducer";
import errorReducer from "./ApplicationDetailsError/ApplicationDetailsErrorReducer";
import submissionsReducer from "./ApplicationDetailsSubmissions/ApplicationDetailsSubmissionsReducer";
import clusterDetailsReducer from "./ClusterCompatibility/ClusterCompatibilityReducer";
import legalDocumentsDetailsReducer from "./LegalDocuments/LegalDocumentsReducer";
import binaryKeyDetailsReducer from "./binaryDetails/BinaryDetailsReducer";
import idsReducer from "./Ids/idsReducer";
import userDataReducer from "./userData/UserDataReducer";
import overViewDetailsReducer from "./overView/OverViewDetailsReducer";
import ContentsDetailsReducer from "./contents/ContentsDetailsReducer";
import OemAdminCountryDetailsReducer from "./Oem-admin-counties/OemAdminCountryDetailsReducer";
import portfolioContentDetailsReducer from "./PortfolioContents/PortfolioContentsReducer";
import OemAdminEcuReducer from "./Ecu-types/OemAdminEcuReducer";
import applicationDetailsAgeRatingReducer from "./ApplicationDetailsAgeRatings/ApplicationDetailsAgeRatingsReducer";
import OemAdminTargetEcuReducer from "./Target-Ecu-Types/OemAdminTargetEcuReducer";
import ApprovalHistoryReducer from "./Approval-history/ApprovalHistoryReducer";
import GeneralClientReducer from "./GenerateClient/GenerateClientReducer";
import LegallocaleDocumentsReducer from "./LocalesRedux/LegallocaleDocumentsReducer";
import domainApproverClusterReducer from "./domain-approver-cluster/DomainApproverClusterReducer";
import deletedApplicationsReducer from "./DeletedApplications/DeletedApplicationsReducer";
import domainApproverCountriesReducer from "./domain-approver-countries/DomainApproverCountryReducer";
import domainApproverEcuTypesReducer from "./domain-approver-ecu-types/DomainApproverEcuReducer";
import domainApproverHeadUnitReducer from "./domain-approver-head-unit/DomainApproverHeadUnitReducer";
import globalAdminUsersReducer from "./global-admin-users/GlobalAdminUsersReducer";
import globalAdminDashboardReducer from "./global-admin-users/dashboard/GlobalAdminDashboardReducers";
import globalAdminCategoriesReducer from "./global-admin-users/categories/GlobalAdminCategoriesReducers";
import cognitoUsersReducer from "./cognito-users/CognitoUsersReducer";
import licensingActionsReducer from "./LicensingsActions/LicensionActionsReducer";
import welcomeWizardReducer from "./Welcome-wizard/WelcomeWizardReducer";
import clusterNumberReducer from "./ClusterNumber/ClusterNumberReducer";
import makeModelYearReducer from "./MakeModelYear/MakeModelYearReducer";
import flexMetaDataReducer from "./FlexMetaData/FlexMetaDataReducer";
import DSAOemAdminReducer from "./DSAOemAdminUrl/DSAOemAdminReducer";
import AddLanguageDialogReducer from "./AddLanguageDialog/AddLanguageDialogReducer";
import GlobalAdminFlexReducers from "./global-admin-users/flex metadata/GlobalAdminFlexReducers";
import agreementDetailsReducer from "./agreement-details/AgreementDetailsReducer";
import applicationReducer from "./domain-approver-applicationList/DomainApproverApplicationListReducer";
import OemAdminApplicationListReducer from "./oem-admin-applicationList/OemAdminApplicationListReducer";
import dsaReviewReducer from "./dsa-review/DSAReviewReducer";

const appReducer = combineReducers({
  applicationDetails: applicationidDetailsReducer,
  submissionDetails: aplicationDetailsReducer,
  categoryDetails: categoryDetailsReducer,
  teamDetails: teamDetailsReducer,
  languageDetails: languageDetailsReducer,
  countryDetails: countryDetailsReducer,
  vehiclesDetails: vehiclesDetailsReducer,
  cpuDetails: cpuDetailsReducer,
  screenshotsDetails: screenshotDetailsReducer,
  bannerDetails: bannerDetailsReducer,
  applicationAdditonalDocumentDetails: applicationAdditonalDocumentReducer,
  binaryDetails: applicationBinaryDetailsReducer,
  applicationAllSubmissions: submissionsReducer,
  idsDetails: idsReducer,
  clusterDetails: clusterDetailsReducer,
  legalDocumentDetails: legalDocumentsDetailsReducer,
  binaryKeyDetails: binaryKeyDetailsReducer,
  userDetails: userDataReducer,
  overViewList: overViewDetailsReducer,
  contentAppList: ContentsDetailsReducer,
  oemAdminCountires: OemAdminCountryDetailsReducer,
  portfolioContents: portfolioContentDetailsReducer,
  oemAdminEcuTypes: OemAdminEcuReducer,
  appDetailsAgeRatings: applicationDetailsAgeRatingReducer,
  targetEcuType: OemAdminTargetEcuReducer,
  approvalHistory: ApprovalHistoryReducer,
  generalClient: GeneralClientReducer,
  oemAdminLocales: LegallocaleDocumentsReducer,
  domainApproverCluster: domainApproverClusterReducer,
  deletedApplications: deletedApplicationsReducer,
  domainApproverCountries: domainApproverCountriesReducer,
  domainApproverEcuTypes: domainApproverEcuTypesReducer,
  domainApproverHeadUnit: domainApproverHeadUnitReducer,
  globalAdminUsers: globalAdminUsersReducer,
  globalAdminDashboard: globalAdminDashboardReducer,
  globalAdminCategories: globalAdminCategoriesReducer,
  cognitoUsers: cognitoUsersReducer,
  licenseReducer: licensingActionsReducer,
  welcomeWizard: welcomeWizardReducer,
  clusterNumberReducer: clusterNumberReducer,
  makeModelYearReducer: makeModelYearReducer,
  flexMetaDataReducer: flexMetaDataReducer,
  DSAOemAdminReducer: DSAOemAdminReducer,
  agreementDetails: agreementDetailsReducer,
  errors: errorReducer,
  addLanguageDialog: AddLanguageDialogReducer,
  globalAdminFlexReducers: GlobalAdminFlexReducers,
  applications: applicationReducer,
  oemAdminSelf: OemAdminApplicationListReducer,
  dsaReview: dsaReviewReducer,
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === "BROWSER_BACK_BUTTON_CLICKED") {
    // we keep a reference of the keys we want to maintain
    // other keys will be passed as undefined and this will call
    // reducers with an initial state
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;